export default __webpack_public_path__ + "static/media/risk-bars-high-dark.695f66e5.svg";